import React from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green'
import { withStyles } from '@material-ui/core/styles';

import SaveIcon from '@material-ui/icons/Save';


const styles = theme => ({
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display: 'inline-block'
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
})

class DialogContainer extends React.Component {

    state = {
        loading: false,
    }

    componentWillReceiveProps(props) {
        if(props.loading === undefined) {
            return
        }
        if(props.loading !== this.state.loading) {
            this.setState({
                loading: props.loading
            })
        }
    }

    onClickAction = () => {
        this.setState({
            //loading: true
        })
        this.props.onClick()
    }

    render() {

        const { loading } = this.state;
        const {
            classes,
            color,
            variant,
            disabled
        } = this.props;

        if(disabled) {
            return <div className={classes.wrapper}>
                <Button size="small" color={color} variant={variant} onClick={this.onClickAction} disabled={true}>
                    {this.props.icon === "save" && <SaveIcon className="marginRight" />} {this.props.name}
                </Button>
            </div>
        }
        return(
            <div className={classes.wrapper}>
                <Button size="small" color={color} variant={variant} onClick={this.onClickAction} disabled={loading}>
                    {this.props.icon === "save" && <SaveIcon className="marginRight" />} {this.props.name}
                </Button>
                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
        )
    }

}

export default withStyles(styles)(DialogContainer);



// WEBPACK FOOTER //
// ./src/Components/LoaderButton.js